export interface ContactFieldMetadata {
	type: string;
	prim: boolean;
	active: boolean;
	weight: number;
}

export class ContactFieldMetadataModel implements ContactFieldMetadata {
	type: string;
	prim: boolean;
	active: boolean;
	weight: number;
}

export class ContactFieldValueModel extends ContactFieldMetadataModel {
	value: string;
}

export class ContactFieldPhoneModel extends ContactFieldValueModel {
	phone?: string | number;
	sms: boolean;
}
